import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

export type SensitiveDataAccessSortDirection = 'asc' | 'desc';

export interface SensitiveDataAccessEvent {
  id: string;
  createdAt: string;
  actorType: string;
  actorId: string;
  actorFirstName: string | null;
  actorLastName: string | null;
  actorEmail: string | null;
  businessPurposeCode: string | null;
  referenceType: string | null;
  referenceId: string | null;
  action: string;
  resourceType: string | null;
  resourceId: string | null;
  resourceName: string | null;
  eventType: string;
  outcomeCode: string | null;
  subjectCount: number;
  rowCount: number | null;
}

export interface SensitiveDataAccessListParams {
  limit: number;
  offset: number;
  search: string;
  sortBy: string;
  sortDirection: SensitiveDataAccessSortDirection;
}

@Injectable({ providedIn: 'root' })
export class SensitiveDataAccessService {
  private readonly basePath = 'admin/reports/sensitive-data-exposures';

  constructor(private restangular: Restangular) {}

  listEvents(params: SensitiveDataAccessListParams): Promise<SensitiveDataAccessEvent[]> {
    return this.restangular
      .one(this.basePath)
      .customGET('', params)
      .toPromise() as Promise<SensitiveDataAccessEvent[]>;
  }
}
